import React, { useState } from "react";
import { Navbar, Nav, Container, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import api from "../../../Environment";
import configuration from "react-global-configuration";
import "./header.css";

const Header = (props) => {
  const [staticPages2, setStaticPages2] = useState(
    configuration.get("configData.footer_pages2")
  );

  const findPage = (staticPages2, static_page_id) => {
    return staticPages2.find((obj) => {
      if (obj.static_page_id == static_page_id) {
        return obj.static_page_unique_id;
      } else {
        return "";
      }
    });
  };

  return (
    <Navbar
      expand="lg"
      className={`py-5 px-0 ${props?.bgcolor ? "gradient-bg" : ""}`} // top space + no x-padding on navbar
    >
      <div className="container pb-5">
        {" "}
        {/* no container padding */}
        {/* Left Logo */}
        <Navbar.Brand
          href="/"
          // className="ps-3 text-white navbar-brand pb-5"
        >
          <Image
            src={
              api.serviceUrl() + "/" + configuration.get("configData.site_logo")
            }
            width="200"
            className="desktop-img"
          />

          {/* <Image
            src={
              api.serviceUrl() + "/" + configuration.get("configData.site_icon")
            }
            width="50"
            className="mobile-img"
          /> */}
        </Navbar.Brand>
        {/* <Navbar.Toggle aria-controls="main-nav" /> */}
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span>
            <i className="fas fa-bars text-white fa-2x" />
          </span>
        </Navbar.Toggle>
        {/* Right Menus (flush right) */}
        <Navbar.Collapse
          id="main-nav"
          className="justify-content-end align-self-end"
        >
          <Nav className="me-3 font-bold">
            <Nav.Link href="/" className="text-white px-3">
              HOME
            </Nav.Link>
            {/* margin end for breathing room */}
            <Nav.Link
              href={"/page/" + findPage(staticPages2, 9)?.static_page_unique_id}
              className="text-white px-3"
              target="_blank"
            >
              HOW IT WORKS
            </Nav.Link>
            <Nav.Link
              href="/page/about"
              className="text-white px-3"
              target="_blank"
            >
              ABOUT US
            </Nav.Link>
            <Nav.Link
              href={
                "/page/" + findPage(staticPages2, 10)?.static_page_unique_id
              }
              className="text-white px-3"
              target="_blank"
            >
              SUBSCRIBER FAQ
            </Nav.Link>
            <Nav.Link
              href={
                "/page/" + findPage(staticPages2, 11)?.static_page_unique_id
              }
              className="text-white px-3"
              target="_blank"
            >
              CREATOR FAQ
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default Header;
